module.exports = __webpack_public_path__ + "img/logo.8a55b1e6.png";